import { addressAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';

export default {
  async fetchMyAddressList({ state, commit }, payload) {
    if (payload.page) commit('initList');
    const { page, limit, totalPage } = state;
    if (page > totalPage) return;

    const { data } = await ServiceExec.get(addressAPI.address_list, payload);
    const { list, pageInfo } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
    return data;
  },

  async setPrimary({ state, commit }, payload) {
    const { userNo, addressNo } = payload;
    const { data, status } = await ServiceExec.patch(
      addressAPI.set_primary(userNo, addressNo)
    );

    return data;
  },

  async delete({ state, commit }, addressNo) {
    const { data, status } = await ServiceExec.delete(
      addressAPI.delete(addressNo)
    );
    if (data) {
      const { userNo } = store.getters['user/getUserData'];
      await store.dispatch('address/fetchMyAddressList', {
        page: 1,
        userNo: userNo
      });
      return true;
    } else {
      return false;
    }
  },

  async save({ state, commit }, payload) {
    const { data, status } = await ServiceExec.post(addressAPI.save, payload);
    return data;
  }
};
